export const documentConfigurationEn = {
  duplicate_document_settings: `Duplicate document settings`,
  configure_how_duplicate_documents_should_be_handled:
    "Configure how duplicate documents should be handled",
  replace_duplicate: "Replace duplicate ({{documentType}})",
  replace_duplicate_explain: `Whenever a new {{documentType}} is detected as a duplicate, the system will replace the old {{documentType}} with the new one.`,
  email_user_about_duplicate_document: "Email user about duplicate document",
  send_email_to_user_when_duplicate_is_detected:
    "Send email to user when duplicate is detected",
  email_supplier_about_duplicate_document:
    "Email supplier about duplicate document",
  send_email_to_supplier_when_duplicate_is_detected:
    "Send email to supplier when duplicate is detected",
  integration_settings: `Integration settings`,
  control_document_behavior_for_integrated_systems: `Control document behavior for integrated systems`,
  disable_update_and_delete_for_integrated_documents: `Disable update and delete for integrated documents`,
  disable_update_and_delete_for_integrated_documents_explain: `Prevent modifications to documents synced with integrated systems`,
  enable_auto_remove_duplicate_document: `Enable Auto-Remove Duplicate Documents`,
  enable_auto_remove_duplicate_document_description: `Automatically remove duplicate documents to prevent duplicate entries`,
  additional_duplicate_detection_fields:
    "Duplicate detection - additional fields",
  additional_duplicate_detection_fields_description:
    "Configure additional fields along with documentid and vendorId for duplicate detection",
  search_fields: `Search fields`,
  decimal_precision: "Decimal Precision",
  decimal_precision_description:
    "Configure the decimal precision for numeric fields in documents (used during post-processing)",
  number_format: "Number Format",
  select_number_format: "Select number format",
  four_decimals: "4 decimals",
  three_decimals: "3 decimals",
  two_decimals: "2 decimals",
};
